import { render, staticRenderFns } from "./ThemeStyle.vue?vue&type=template&id=b4355fc4&scoped=true"
import script from "./ThemeStyle.vue?vue&type=script&lang=js"
export * from "./ThemeStyle.vue?vue&type=script&lang=js"
import style0 from "./ThemeStyle.vue?vue&type=style&index=0&id=b4355fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4355fc4",
  null
  
)

export default component.exports